import * as React from "react";
import { SVGProps } from "react";
const SvgBriefcase = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 5h-8v2h-2V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h-2V5ZM4 28h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2ZM4 9h24v5H4V9Zm15 7h9v10H4V16h9v2h6v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBriefcase;
